export default "__VITE_ASSET__be531b16__"